<template>
    <div class="buy-list flex f-v">
        <div class="type-wrap f-shark0">
            <div class="type flex f-v-center f-h">
                <div class="type-item f-grow"
                     @click="toggle('g')"
                     :class="{sel: data.sel === 'g'}">
                    <img class="p" :src="require('@/assets/icons/t1.png')"/>
                    <img class="n" :src="require('@/assets/icons/t1-s.png')"/>
                    <span>团课</span>
                </div>
                <div class="type-item f-grow"
                     @click="toggle('s')"
                     :class="{sel: data.sel === 's'}">
                    <img class="p" :src="require('@/assets/icons/t2.png')"/>
                    <img class="n" :src="require('@/assets/icons/t2-s.png')"/>
                    <span>私教</span>
                </div>
            </div>
            <div class="week-wrap flex f-h ">
                <div class="week flex f-v f-v-center f-grow"
                     v-for="(item, i) in data.date"
                     @click="selectDay(item, i)"
                     :class="{bg: i === data.selIndex}"
                     :key="item.weekStr">
                    <div class="week-str">{{item.isToday ? '今天' : item.weekStr}}</div>
                    <div class="day">{{item.day}}</div>
                    <div class="m">{{item.month}}月</div>
                </div>
            </div>
        </div>

        <div class="list f-grow">

            <loading  v-if="data.loading"/>

            <div v-else-if="data.showFuck" class="fuck-after-day">
                <img :src="require('@/assets/icons/fuck.png')"/>

                <div >不可预约三天后课程</div>
            </div>

            <div v-else-if="data.sel === 'g'"
                 v-for="(item, i) in data.nowList"
                 :key="i"
                 class="k"
                 @click="router.push(`/info?id=${item.id}&t=${data.selObj.qs}`)">
                <div class="title flex f-v-center f-sb">
                    <!--<div class="t">{{t.formatDate(item.start, 'hh:mm')}} - {{t.formatDate(item.end, 'hh:mm')}}</div>-->
                    <div class="t">{{item.start}} - {{item.end}}</div>
                    <div class="n flex f-v-center">
                        <span>预约 {{(item.user || []).length}}/{{item.num}}</span>
                        <span class="flex f-v-center" style="margin-left:6px">
                            <img v-for="(u,j) in (item.user || [])" :key="j"
                                 style="width:1.4em;height:1.4em;border-radius:50%;margin-left:-6px;border:1.5px solid #fff;object-fit:cover"
                                 :src="(typeof u==='string' ? u : (u&&u.url)) || require('@/assets/icons/user.png')"/>
                        </span>
                    </div>
                </div>
                <div class="info flex f-h ">
                    <div class="img flex f-v-center f-shark0">
                        <img :src="req.host + item.url"/>
                    </div>
                    <div class="str f-grow">
                        <div class="s1 flex f-v-center">
                            <span>{{item.name}}</span>
                            <img :src="require('@/assets/icons/fire.png')"/>
                        </div>
                        <div class="s2 flex f-v-center">
                            <span class="mr20">难度</span>
                            <star :val="Number(item.difficulty)"/>
                        </div>
                        <div class="s2 txt-ellipsis">{{item.coach_name}}</div>
                        <div class="s2 flex f-sb txt-ellipsis">
                            <span>团课</span>
                            <span style="padding-right: 10px;">¥200</span>
                        </div>
                    </div>
                </div>
            </div>

            <div v-else
                 v-for="(item, j) in data.nowList"
                 :key="j"
                 class="pp flex f-h ">
                <div class="img flex f-v-center f-shark0">
                    <img :src="req.host + item.url"/>
                </div>
                <div class="str f-grow flex f-v f-sa">
                    <div class="s1 flex f-sb f-v-center">
                        <span>{{item.name}}</span>
                        <button class="btn" @click="showCoachInfo(item)">预约</button>
                    </div>
                    <div class="s2 txt-ellipsis">从业 {{item.seniority}}</div>
                    <div class="s2 ">{{item.content}}</div>
                </div>
            </div>

            <empty v-if="!data.loading && data.nowList.length <= 0"
                   height="50vh"
                   :hint="data.sel === 'g' ? '今天没有团课~' : '今天没有教练~'"/>

        </div>


        <transition-group name="fade">
            <div class="confirm-content buy-dlg time-select" v-if="data.showCoach">
                <div class="title">预约教练</div>
                <div class="msg flex f-wrap" >
                    <div v-for="(t, i) in data.timeList"
                         :class="{'used': t.isUsed, 'sel': t.select}"
                         @click="selectTimeF(t, i)"
                         class="time-item">
                        <span>{{t.h}}:{{t.m}}</span>
                    </div>

                </div>
                <div class="hint" style="margin: -20px 0 20px;">提示: 预约需扣除5格时间</div>
                <div class="room-select" style="margin: -10px 0 15px;text-align:left;padding:0 10px">
                    <span style="color:#606060;font-size:.24rem;margin-right:10px">教室</span>
                    <select v-model="data.selRoomId" style="padding:5px 10px;border-radius:4px;border:1px solid #ddd;font-size:.24rem">
                        
                        <option v-for="r in data.roomList" :key="r.id" :value="r.id">{{r.name}} ({{r.venue_name}})</option>
                    </select>
                </div>

                <div class="ctl flex f-sa">
                    <button class="btn cancel"
                            @click="data.showCoach = false">取消</button>
                    <!--<button class="btn ok"
                            @click="useCoach()">确认</button>-->
                    <wx-open-subscribe
                            @success="useCoach()"
                            @error="useCoach()"
                            template="HX_vqEIqRVfvUXsMdWWV1us4JR0mOngAd-zLNVlSVLY,dtm8jR9Rab87EmlCVlAwXs8oylnztkLzSBLjyPdn_RU"
                            id="subscribe-btn">
                        <component :is="'script'" type="text/wxtag-template" slot="style">
                            <component :is="'style'">
                                .subscribe-btn {
                                border-radius: 20px 20px 20px 20px;
                                border: 1px solid #40D9C7;
                                background-color: #40D9C7;
                                color: #fff;
                                padding: 10px 5px;
                                min-width: 98px;
                                font-size: 14px;
                                }
                            </component>
                        </component>
                        <component :is="'script'" type="text/wxtag-template">
                            <button class="subscribe-btn">确认</button>
                        </component>
                    </wx-open-subscribe>
                </div>
            </div>
            <div class="confirm-bg" v-if="data.showCoach"></div>
        </transition-group>
    </div>
</template>

<script setup>
    import confirm from '@/lib/confirm.js';
    import empty from '@/components/empty.vue';
    import star from '../components/star.vue';
    import Loading from '@/components/LLoading.vue';
    import router from '../router/index.js';
    import waitInit from '@/lib/init.js';
    import api from '@/api/api.js';
    import req from '@/api/request.config.js';
    import t from '@zh-or/lib';
    import u from '@/lib/tools.js';
    import {ref, reactive} from 'vue';

    let data = reactive({
        sel: 'g',
        date: [],
        selIndex: 0,
        selObj: null,
        loading: true,

        dataCache: {},
        nowList: [],

        showFuck: false,

        showCoach: false,
        coachObj: null,
        roomList: [],
        selRoomId: 0,

        timeList: [],
    });
    let weekDays = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];

    function init() {
        let now = new Date();
        let day = now.getDay();
        data.date.push({
            i: 0,
            weekDay: getWeekDayOf7(day),
            weekStr: weekDays[day],
            isToday: true,
            month: now.getMonth() + 1,
            day: t.formatDate(now, 'dd'),
            qs: t.formatDate(now, 'yyyy-MM-dd'),
        });

        for(let i = 1; i < 6; i++) {
            now.setDate(now.getDate() + 1);
            let w = now.getDay();
            let day = now.getDate();
            data.date.push({
                i: i,
                weekDay: getWeekDayOf7(w),
                weekStr: weekDays[w],
                isToday: false,
                month: now.getMonth() + 1,
                day: t.formatDate(now, 'dd'),
                qs: t.formatDate(now, 'yyyy-MM-dd'),
            });
        }

        selectDay(data.date[0], 0);

    }

    function getWeekDayOf7(d) {
        if(d == 0) {
            return 7;
        }
        return d;
    }

    function toggle(str) {
        data.sel = str;
        loadGroupByDay();
    }

    function selectDay(obj, i) {
        data.selIndex = i;
        data.selObj = obj;

        loadGroupByDay();
    }

    waitInit(() => {
        init();
    });

    function loadGroupByDay(noCache) {
        let key = data.sel + '-' + data.selObj.qs;
        console.log(key, data);
        /*if(data.dataCache[key] && !noCache) {
            data.nowList = data.dataCache[key];
            return;
        }*/

       data.loading = true;
        let call = data.sel === 'g' ? api.getGroupList : api.getCoachList;

        call({time: data.selObj.qs})
            .then(res => {
                if(res.code === 1) {
                    var list = res.data;
                    if (data.sel === 's' && list.coaches) {
                        data.roomList = list.rooms || [];
                        list = list.coaches;
                    }
                    data.dataCache[key] = list;
                    data.nowList = list;
                    data.loading = false;
                }
            })
            .catch(e => {
                console.error('加载数据出错: ', e);
            })

    }

    function showCoachInfo(obj) {
        data.coachObj = obj;

        let coachEndTime = t.parseDate(data.selObj.qs + ' ' + (obj.end || '22:00') + ':00');

        data.timeList = [];
        let stepTime = 15;//min
        let endHours = coachEndTime.getHours();
        //教练上班时间
        let timeStr = data.selObj.qs + ' ' + (obj.start || '07:00') + ':00';

        let time = t.parseDate(timeStr);

        //time.setHours(7);
        //time.setMinutes(0);
        time.setSeconds(0);
        time.setMilliseconds(0);

        let isInTime = (currentTime) => {
            console.log(
                t.formatDate(currentTime, 'yyyy-MM-dd hh:mm:ss'),
                t.formatDate(new Date()),
                currentTime.getTime() < Date.now()
            )
            if(currentTime.getTime() < Date.now()) {
                return true;
            }
            for(let i = 0; i < obj.time.length; i++) {
                let time = obj.time[i];
                let ts = t.parseDate(`${data.selObj.qs} ${time.start}:00`);
                let te = t.parseDate(`${data.selObj.qs} ${time.end}:00`);
                let utc = currentTime.getTime();
                /*console.log(utc >= ts.getTime() && utc <= te.getTime(),
                    t.formatDate(ts, 'yyyy-MM-dd hh:mm:ss'),
                    t.formatDate(currentTime, 'yyyy-MM-dd hh:mm:ss'),
                    t.formatDate(te, 'yyyy-MM-dd hh:mm:ss')
                );*/
                if(utc >= ts.getTime() && utc <= te.getTime()) {

                    return true;
                }
            }
            // 检查教练屏蔽时段
            if (obj.blocked && obj.blocked.length) {
                for (let bi = 0; bi < obj.blocked.length; bi++) {
                    let b = obj.blocked[bi];
                    let bd = b.day || '';
                    let bs = b.start || '';
                    let be = b.end || '';
                    if (bd && bs && be) {
                        let bts = t.parseDate(bd + ' ' + bs + ':00');
                        let bte = t.parseDate(bd + ' ' + be + ':00');
                        if (bts && bte && currentTime.getTime() >= bts.getTime() && currentTime.getTime() <= bte.getTime()) {
                            return true;
                        }
                    }
                }
            }
            // 检查教练屏蔽时段
            if (obj.blocked && obj.blocked.length) {
                for (let bi = 0; bi < obj.blocked.length; bi++) {
                    let b = obj.blocked[bi];
                    let bd = b.day || '';
                    let bs = b.start || '';
                    let be = b.end || '';
                    if (bd && bs && be) {
                        let bts = t.parseDate(bd + ' ' + bs + ':00');
                        let bte = t.parseDate(bd + ' ' + be + ':00');
                        if (bts && bte && currentTime.getTime() >= bts.getTime() && currentTime.getTime() <= bte.getTime()) {
                            return true;
                        }
                    }
                }
            }
            return false;
        }

        while(true) {
            data.timeList.push({
                h: t.formatDate(time, 'hh'),
                m: t.formatDate(time, 'mm'),
                full: t.formatDate(time, 'yyyy-MM-dd hh:mm'),
                hm: t.formatDate(time, 'hh:mm'),
                isUsed: isInTime(time),
            });
            time.setMinutes(time.getMinutes() + stepTime);
            console.log('------------------->', t.formatDate(time));
            if(time.getHours() >= endHours && time.getMinutes() != 0) {
                break;
            }
        }

        data.selRoomId = 0;
        data.showCoach = true;
    }

    function selectTimeF(t2, i) {
        data.timeList.forEach(v => {
            v.select = false;
        });
        if(!selectTime(t2, i)) {
            t.showToast('该时间段已有其他人预约!');
        }
    }

    function selectTime(_t, i, count) {
        count = count || 0;
        if(count >= 5) {
            return true;
        }
        let t = data.timeList[i + count];
        if(!t) {
            //t.showToast('请选择满3个')
            return false;
        }
        if(!t.isUsed && selectTime(t, i, (count || 0) + 1)) {
            t.select = true;
            return true;
        }
        return false;
    }

    function useCoach() {
        let times = data.timeList.filter(_ => _.select);
        if(times.length < 4) {
            t.showToast('不满5格时间!');
            return ;
        }
        data.showCoach = false;
        confirm('提示', `确认预约 ${data.selObj.qs} 的<br> ${times.map(_ => _.hm).join(', ')} 吗?`)
            .then(_ => {
                t.showWait('预约中...');
                api.useCoach({
                    day: data.selObj.qs,
                    start: times[0].hm,
                    end: times[times.length-1].hm,
                    coach_id: data.coachObj.coach_id,
                    room_id: data.selRoomId || 0
                })
                    .then(res => {
                        t.hideWait();
                        if(res.code === 1) {
                            t.showToast('预约成功!');
                            loadGroupByDay(true);
                        }
                    })
                    .catch(e => {
                        t.hideWait();
                        t.showToast('预约失败, 网络错误!');
                    })
            })
            .catch(_ => {
                data.selRoomId = 0;
        data.showCoach = true;
            });
    }

</script>

<style lang="scss">
.buy-list {
    height: 100%;
    padding: $page-lr-pd;

    .type-wrap {
        .type {
            box-shadow: 0px 0px 20px 3px rgba(0,0,0,0.05);
            border-radius: 10px 10px 10px 10px;
            overflow: hidden;
            background-color: #fff;

            .type-item {
                font-size: .28rem;
                color: #40D9AE;
                padding: 3px 20px;
                transition: all .1s;
                text-align: center;

                img {
                    height: 1em;
                    margin-right: 10px;
                }

                .n {display: none;}

                &.sel {
                    color: #fff;
                    background-color: #40D9AE;

                    .p {display: none;}
                    .n {display: inline-block;}
                }
            }
        }

        .week-wrap {
            margin-top: 10px;
            background: #40D9C7;
            box-shadow: 0px 0px 20px 3px rgba(0,0,0,0.05);
            border-radius: 10px 10px 10px 10px;

            .week {
                color: #fff;
                padding: 20px 0 15px;

                &.bg {
                    background: url("~@/assets/icons/week-bg.png") no-repeat center bottom;
                    background-size: 81% 93%;
                }

                .week-str {
                    font-size: .26rem;
                }

                .day {
                    font-size: .32rem;
                    padding: 3px 0;
                }

                .m {
                    font-size: .24rem;
                }
            }
        }
    }

    .list {
        overflow-y: auto;
        margin-top: -10px;
        background: #FFFFFF;
        box-shadow: 0px 0px 20px 3px rgba(0,0,0,0.05);
        border-radius: 10px 10px 10px 10px;
        padding: 10px;

        .k {
            background: #FFFFFF;
            box-shadow: 0px 0px 20px 3px rgba(0,0,0,0.05);
            border-radius: 10px 10px 10px 10px;
            margin-bottom: 10px;
            padding: 10px 0;

            .title {
                font-size: .24rem;

                .t {
                    text-align: left;
                    width: 50%;
                    padding: 5px;
                    color: #fff;
                    background: linear-gradient( 90deg, #40D8C6 0%, rgba(64,216,198,0.8) 65%, rgba(64,217,199,0) 100%);
                }

                .n {
                    color: #606060;
                    padding-right: 20px;
                }
            }

            .info {
                padding: 8px 0;
                color: #606060;
                font-size: .24rem;

                .img {
                    width: 50%;
                    margin-right: 10px;
                    border-radius: 5px 5px 5px 5px;
                    overflow: hidden;

                    img {
                        width: 100%;
                    }
                }

                .s1 {
                    font-size: .36rem;
                    font-weight: bold;

                    img {
                        height: 1.2em;
                        margin-left: 5px;
                        display: inline-block;
                    }
                }

                .s2 {
                    margin: 5px 0;
                }
            }
        }

    }

    .fuck-after-day {
        height: 50vh;
        text-align: center;

        img {
            margin: 40px 0;
            width: 5em;
            height: 5em;
        }

        div {
            color: #C6C6C6;
            font-size: .44rem;
            font-weight: bold;
        }
    }

}
</style>
